import { Bet, BetPosition } from '../hooks/types';

/** A prediction bet carries at most one BUY fill (and potentially one SELL once sold). */
export const getBuyFill = (bet: Bet): BetPosition | undefined =>
    (bet.positions ?? []).find(position => position.side === 'BUY' && position.quantity > 0);

/** The actual cost of a prediction bet once the venue fee settles; the debited stake until then. */
export const getPredictionBetCost = (bet: Bet): number => {
    const betAmount = getBuyFill(bet)?.bet_amount;
    return betAmount != null && betAmount > 0 ? betAmount : bet.stake;
};

/** Filled contracts pay $1 each, so the payout is the contract count; undefined until the order fills. */
export const getPredictionBetPayout = (bet: Bet): number | undefined => getBuyFill(bet)?.quantity;
